import { i18n } from "@lingui/core";
import { Brand, Subvertical } from "../constants.js";

const READ_MORE_CONFIG: Record<Brand, Partial<Record<Subvertical, string>>> = {
    finn: {
        car: "https://www.finn.no/motor/artikler/bil",
        boat: "https://www.finn.no/motor/artikler/bat",
        mc: "https://www.finn.no/motor/artikler/mc",
    },
    blocket: {
        car: "https://www.blocket.se/bilguiden",
        boat: "https://www.blocket.se/tips-och-guider/bat",
    },
    dba: {
        car: "https://blog.bilbasen.dk/",
    },
};

export const getReadMoreLink = (brand: Brand, subvertical: Subvertical): string | null => {
    const brandConfig = READ_MORE_CONFIG[brand];
    return brandConfig?.[subvertical] || null;
};

type EverGreenConfig = Record<Brand, Record<string, Array<{ title: string; link: string; imageUrl: string; badge: string }>>>;

export const EVERGREEN_CONFIG: EverGreenConfig = {
    finn: {
        car: [
            {
                title: "Prøvekjøre bruktbil - dette bør du se etter",
                link: "/motor/artikler/bil/provekjore-bruktbil-dette-bor-du-se-etter",
                imageUrl: "/editorial-content/car/finn/finn-motor-provekjor-bruktbil.webp",
                badge: "Kjøpe bruktbil",
            },
            {
                title: "Elbil, hybrid, bensin eller diesel?",
                link: "/motor/artikler/bil/elbil-hybrid-bensin-eller-diesel",
                imageUrl: "/editorial-content/car/finn/finn-motor-elbil-hybrid-besin-eller-diesel.webp",
                badge: "Kjøpe bruktbil",
            },
            {
                title: "Hva slags bruktbil har du råd til?",
                link: "/motor/artikler/bil/hva-slags-bruktbil-har-du-rad-til",
                imageUrl: "/editorial-content/car/finn/finn-motor-hva-slags-bruktbil-har-du-rad-til.webp",
                badge: "Kjøpe bruktbil",
            },
        ],
        boat: [
            {
                title: "Båtreparatør: - Mange oppdager ikke disse feilene før de kjøper brukt",
                link: "/motor/artikler/bat/batreparator-mange-oppdager-ikke-disse-feilene-for-de-kjoper-brukt",
                imageUrl: "/editorial-content/boat/finn/finn-motor-boat-mange-oppdager-ikke-disse-feilene.webp",
                badge: "Kjøpe båt",
            },
            {
                title: "5 tips til deg som skal kjøpe båt",
                link: "/motor/artikler/bat/5-tips-til-deg-som-skal-kjope-bat",
                imageUrl: "/editorial-content/boat/finn/finn-motor-boat-Tips-batskjop.webp",
                badge: "Kjøpe båt",
            },
            {
                title: "Sånn får du solgt båten",
                link: "/motor/artikler/bat/sann-far-du-solgt-baten",
                imageUrl: "/editorial-content/boat/finn/finn-motor-boat-sann-far-du-solgt-baten.webp",
                badge: "Selge båt",
            },
        ],
        mc: [
            {
                title: "Gode tips for å finne en rimelig og god bruktmotorsykkel",
                link: "/motor/artikler/mc/pass-deg-for-denne-avgiftsfella-nar-du-kjoper-brukt-mc",
                imageUrl: "/editorial-content/mc/finn/finn-motor-mc-gode-tips-for-a-finne-en-god-bruktmotorsykkel.webp",
                badge: "Kjøpe MC",
            },
            {
                title: "10 tips du bør sjekke før du kjøper brukt motorsykkel",
                link: "/motor/artikler/mc/10-tips-du-bor-sjekke-for-du-kjoper-brukt-motorsykkel",
                imageUrl: "/editorial-content/mc/finn/finn-motor-mc-10-tips-du-bor-sjekke.webp",
                badge: "Kjøpe MC",
            },
            {
                title: "Derfor er kjøpekontrakt for brukt MC en veldig god idé!",
                link: "/motor/artikler/mc/kjopekontrakt-for-mc-er-en-veldig-god-ide-1",
                imageUrl: "/editorial-content/mc/finn/finn-motor-mc-kjopekontrakt-for-mc.webp",
                badge: "Kjøpe MC",
            },
        ],
        b2b: [],
    },
    // DBA content
    dba: {
        car: [
            {
                title: "Guide: Sådan prøvekører du en brugt bil som en professionel",
                link: "https://blog.bilbasen.dk/guide-sadan-provekorer-du-en-brugt-bil-som-en-professionel",
                imageUrl: "/editorial-content/car/dba/dba-bilbasen-blog-guide-sadan-provkorer-du-en-brugt-bil.webp",
                badge: "Forbrugerstof",
            },
            {
                title: "Her er de 10 mest populære biler i 2025",
                link: "https://blog.bilbasen.dk/her-er-de-10-mest-populaere-biler-i-2025",
                imageUrl: "/editorial-content/car/dba/dba-bilbasen-blog-her-er-de-10-mest-populaere-biler-i-2025.webp",
                badge: "Forbrugerstof",
            },
            {
                title: "Video: Cupra Born er vinderen af Årets Brugtbil 2025",
                link: "https://blog.bilbasen.dk/vinderen-af-arets-brugtbil-2025",
                imageUrl: "/editorial-content/car/dba/dba-bilbasen-blog-arets-brugtbil-2025.webp",
                badge: "Video",
            },
        ],
        boat: [],
        mc: [],
        b2b: [],
    },
    // BLOCKET content
    blocket: {
        car: [
            {
                title: "Bilduellen: Volvo V70 vs Volkswagen Passat",
                link: "/bilguiden/kopa-och-salja-bil/bilduellen-volvo-v70-vs-volkswagen-passat-vilken-borde-du-satsa-pa",
                imageUrl: "/editorial-content/car/blocket/blocket-bilguiden-Volvo-V70-vs-Volkswagen-Passat.webp",
                badge: "Köpa & sälja bil",
            },
            {
                title: "10 säkraste begagnade bilarna 2025",
                link: "/bilguiden/kopa-och-salja-bil/10-saekraste-begagnade-bilarna-2025",
                imageUrl: "/editorial-content/car/blocket/blocket-bilguiden-10-sakraste-begagnade-bilarna.webp",
                badge: "Köpa & sälja bil",
            },
            {
                title: "Guide: Så provkör du en begagnad bil – som ett proffs",
                link: "/bilguiden/kopa-och-salja-bil/guide-sa-provkoer-du-en-begagnad-bil-som-ett-proffs",
                imageUrl: "/editorial-content/car/blocket/blocket-bilguiden-sa-provkor-du.webp",
                badge: "Köpa & sälja bil",
            },
        ],
        boat: [
            {
                title: "Checklista för en trygg båtaffär",
                link: "/fordon/bat/tryggt",
                imageUrl: "/editorial-content/boat/blocket/blocket-boat-tips-for-en-trygg-bataffar.webp",
                badge: "Köpa båt",
            },
            {
                title: "Tio tips när du ska köpa motorbåt",
                link: "/fordon/bat/tiotipskopamotorbat",
                imageUrl: "/editorial-content/boat/blocket/blocket-boat-tio-tips-kopa-motorbat.webp",
                badge: "Köpa båt",
            },
            {
                title: "Så säljer du båten smidigt",
                link: "/fordon/bat/salja-bat",
                imageUrl: "/editorial-content/boat/blocket/blocket-boat-tips-salja-bat.webp",
                badge: "Sälja båt",
            },
        ],
        mc: [],
        b2b: [],
    },
} as const;

export const getEvergreenViewAllLink = (brand: string, subvertical: string): string => {
    const link = getReadMoreLink(brand as Brand, subvertical as Subvertical);
    return link || "/collections";
};

export const getEvergreenItems = (brand: string, subvertical: string) => {
    const brandConfig = EVERGREEN_CONFIG[brand];

    if (!brandConfig) {
        return [];
    }

    return brandConfig[subvertical] || [];
};

export const getMarketingHeader = (subvertical: Subvertical): string => {
    switch (subvertical) {
        case Subvertical.Car:
            return i18n.t({
                id: "frontpage.evergreen-content.title.car",
                message: "Everything you need for a safe car transaction",
            });
        case Subvertical.Boat:
            return i18n.t({
                id: "frontpage.evergreen-content.title.boat",
                message: "Everything you need for a safe boat transaction",
            });
        case Subvertical.Mc:
            return i18n.t({
                id: "frontpage.evergreen-content.title.mc",
                message: "Everything you need for a safe MC transaction",
            });
        default:
            return i18n.t({
                id: "frontpage.evergreen-content.title",
                message: "Everything you need for a safe transaction",
            });
    }
};
